// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-filter-button',
    // #endregion
    // #region Properties
    props: {
        filter: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        isLoading: false,
        isOpen: false,
        selected: [],
        searchText: '',
    }),
    // #endregion
    // #region Constructor
    created() {
        this.updateSelection();
    },
    // #endregion
    // #region Watch
    watch: {
        'searchText': function (search) {
            utils.logError("search", search);
        },
        'filter': function (search) {
            this.updateSelection();
        },
    },
    // #endregion
    // #region Computed
    computed: {
        selectedCount() {
            let tItem = 0;
            if (this.filter.values) {
                this.filter.values.forEach((e) => {
                    if (e.applied) {
                        tItem = tItem + 1;
                    }
                });
            }
            return tItem;
        },
        resultValues() {
            if (this.searchText) {
                return this.filter.values.filter((item) => {
                    return this.searchText.toLowerCase().split(' ').every((v) => item.label.toLowerCase().includes(v));
                });
            }
            else {
                return this.filter.values;
            }
        }
    },
    // #endregion
    // #region Core
    methods: {
        toogleButton() {
            this.isOpen = !this.isOpen;
        },
        closeButton() {
            this.isOpen = false;
        },
        isSelected(value) {
            return this.selected.some(e => e === value.key);
        },
        updateSelection() {
            let tSelection = [];
            this.filter.values.filter((e) => e.applied).forEach((e) => {
                tSelection.push(e.key);
            });
            this.selected = tSelection;
        },
        highlight(word) {
            if (!this.searchText) {
                return word;
            }
            var check = new RegExp(this.searchText, "ig");
            return word.toString().replace(check, function (matchedText, a, b) {
                return ('<strong>' + matchedText + '</strong>');
            });
        },
        toogleSelection(value) {
            //Data
            let tKey = value.key;
            //IsSelected
            if (this.selected.some(e => e === tKey)) {
                this.selected.splice(this.selected.indexOf(tKey), 1);
            }
            else {
                this.selected.push(tKey);
            }
        },
        searchTextClear() {
            //Reset
            this.searchText = '';
            //Focus
            this.$refs.txtSearch.focus();
        },
        resetFilter() {
            this.selected = [];
        },
        applyButton() {
            //State
            this.isOpen = false;
            //Event
            this.$emit("applyFilter", this.filter, this.selected);
        },
    }
    // #endregion
});
// #endregion
